<div class="modal-header">
    <div class="modal-title text-center" style="width: 100%;" id="modal-title">
        <h5 class="mb-0">Confirmación de Superficie Orgánica</h5>
    </div>
  <button
    type="button"
    class="close"
    aria-label="Close button"
    aria-describedby="modal-title"
    (click)="modal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
    <p>Los siguientes productos tienen 0 indicado como valor en "Superficie Orgánica":</p>
    <table class="table table-bordered table-hover">
        <thead class="thead-dark">
            <tr>
                <th>#</th>
                <th>Producto / Especie</th>
                <th>Variedad / Raza / Marca Comercial</th>
                <th>Unidad de producción</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let product of products">
                <tr>
                    <td>{{ product.number }}</td>
                    <td>{{ product.product }}</td>
                    <td>{{ product.type }}</td>
                    <td>{{ product.unit }}</td>
                </tr>
            </ng-container>
        </tbody>
    </table>
    <br>
    <p>Este valor se se utiliza para emitir el certificado, ¿Esta seguro de que son los valores correctos?</p>
</div>

<div class="modal-footer justify-content-center" style="margin-top: 50px">
  <button
    type="button"
    class="btn btn-outline-secondary"
    (click)="modal.close('cancel click')"
  >
    No
  </button>
  <button
    type="button"
    class="btn btn-success"
    (click)="onSubmit()"
  >
    Si
  </button>
</div>